import DataGrid, {
  HeaderFilter,
  Scrolling,
  Column,
  Editing,
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import React, { useCallback, useEffect, useState } from 'react';
import { BoardBody } from '../../components/BoardBody';
import { BoardHeader } from '../../components/BoardHeader';
import master from '../../services/master';
import { Container } from './styles';

export const Languages: React.FC = () => {
  const [segments, setSegments] = useState<DataSource>();
  const [languagesDetailId, setLanguagesDetailId] = useState(0);

  const [open, setOpen] = useState(false);

  const loadLanguages = useCallback(async () => {
    const languagesStore = new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        const { data } = await master.get('/master/languages');
        return data.sort((a: any, b: any) => {
          if (a.Name < b.Name) {
            return -1;
          }
          if (a.Name > b.Name) {
            return 1;
          }
          return 0;
        });
      },
      insert: async data => {
        await master.post('/master/languages', data);
      },
      update: async (id, data) => {
        await master.put(`/master/languages/${id}`, {
          Name: data.Name,
          IsActive: data.IsActive,
          Abbreviation: data.Abbreviation,
        });
      },
    });

    setSegments(
      new DataSource({
        store: languagesStore,
        paginate: true,
        reshapeOnPush: true,
      }),
    );
  }, []);

  useEffect(() => {
    loadLanguages();
  }, [loadLanguages]);

  const boldTextCells = useCallback(
    e => (
      <p
        style={{
          color: '#333333',
          fontSize: '14px',
          fontWeight: 'bold',
          whiteSpace: 'break-spaces',
        }}
      >
        {e.text}
      </p>
    ),
    [],
  );

  return (
    <Container>
      <BoardHeader title="Languages" subtitle="Languages" />
      <BoardBody>
        <DataGrid
          keyExpr="id"
          dataSource={segments}
          onCellClick={e => {
            if (e.rowType === 'data') {
              setLanguagesDetailId(e.key);
              setOpen(true);
            }
          }}
        >
          <Editing allowAdding allowUpdating />
          <HeaderFilter visible allowSearch />
          <Scrolling mode="infinite" />
          <Column dataField="Name" cellRender={boldTextCells} />

          <Column dataField="Abbreviation" allowHeaderFiltering={false} />
          <Column dataField="IsActive" />
        </DataGrid>
      </BoardBody>
    </Container>
  );
};
